import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import Services from '../components/Services';
import Equipe from '../components/Equipe';
import Partenaires from '../components/Partenaires';
import Footer from '../components/Footer';

function Home() {
  return (
    <div className="font-sans">
      <Navbar />
      <Hero />
      <Services />
      <Equipe />
      <Partenaires />
      <Footer />
    </div>
  );
}

export default Home;